import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './main.css';
import './industrial.css';
import AppRouter from './Router';

function AppIndustrial() {
  return (
    <HelmetProvider>
      <AppRouter />
    </HelmetProvider>
  );
}

export default AppIndustrial;